import { createHTTPActions } from '../utils';
import { IAccount } from '../../../shared/models';

export enum EAccountsActions {
  getAccounts = '[Accounts] Get Accounts',
}

const [getAccounts, getAccountsSuccess, getAccountsError] = createHTTPActions<void, IAccount[], Error>(
  EAccountsActions.getAccounts,
);

export const ACCOUNTS_ACTIONS = {
  getAccounts,
  getAccountsSuccess,
  getAccountsError,
};
